import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const StyledRegulationDiv = styled.div`
  height: 33px; /* Try to match invision design */
`;

export const SkeletonTile: FC<{ onClosed?: () => void }> = ({ onClosed }) => {
  return (
    <div
      className="card card-raising card-raised m-0 m-2"
      style={{ width: '364px', height: '364px' }}
      data-e2e="dashboard-tile-skeleton"
    >
      <div className="card-header p-0">
        <div className="d-flex">
          <div className="flex-fill mb-0 ps-3 pt-3">
            <Skeleton width="21em" height="1.6em" />
          </div>
          <button type="button" className="btn-close ms-3 mt-2 me-2" aria-label="Close" onClick={onClosed} />
        </div>
        <div className="d-flex align-items-center ps-3 justify-content-between">
          <span className="tabular-figures text-large flex-fill">
            <Skeleton width="5em" />
          </span>
          <Skeleton width="5em" className="me-2" />
        </div>
        <div className="text-secondary fw-bold text-truncate border-top py-2 mt-2 px-3">
          <Skeleton width="8em" className="me-2" />
          <Skeleton width="3em" />
        </div>
        <div className="d-flex flex-nowrap mt-1 px-3 pb-3">
          <div className="mx-1">
            <Skeleton width="3em" height="1.5em" />
          </div>
          <div className="mx-1">
            <Skeleton width="3em" height="1.5em" />
          </div>
          <div className="mx-1">
            <Skeleton width="3em" height="1.5em" />
          </div>
        </div>
      </div>
      <div className="card-body p-0">
        <Skeleton className="w-100 h-100" />
      </div>
      <div className="card-footer py-2 px-3 d-flex align-items-center">
        <div className="flex-grow-1">
          <StyledRegulationDiv className="d-flex my-3" />
        </div>
        <Skeleton width="2em" />
      </div>
    </div>
  );
};

SkeletonTile.displayName = 'SkeletonTile';
